import React from 'react';
import { getCurrencySymbol } from '../../../data/utils/getCurrencySymbol';

function IsibetHorseTicketSelections(props) {
	const ticketData = props.ticketData;
	const selections = ticketData.bet;
	const clearBoth = {clear: "both"};
	const currency = getCurrencySymbol(props.conf.cs.ct);
	
	return <div style={{marginTop : "2%"}}>
		{
			selections.map(function(selection) {
                const reactKey = selection.outcomes + "-" + selection.betDescription;
                const ippQF = ticketData.reportType === 3;
				return (
                	
                    <div key={reactKey} className="event">
                        {
                        	!ippQF?
                                	<div className="event_row">
                        				<div className="td-10 left">{selection.moltiplicator} </div>
                        				<div className="td-20 left">{selection.betDescription} </div>
                        				<div className="td-40 left textNewLine">{selection.outcomes} </div>
                        				<div className="td-30 left odd textright bold">{currency + ' ' + selection.price}</div>
                        				<div style={clearBoth}></div>
                        			</div>
                        			:
                        			<>
	                        			<div className="event_row">	
	                        				<div className="td-100 bold left">{selection.raceTrack + " " + selection.raceNr + "° CORSA"} </div>
	                        				<div style={clearBoth}></div>
	                        			</div>
	                                    <div className="event_row">	
		                    				<div className="td-20 left">{selection.betDescription} </div>
		                    				<div className="td-70 left bold">{selection.outcome} - {selection.outcomeDescription}</div>		
		                    				<div className="td-10 left odd textright bold">{selection.odd}</div>
		                    				<div style={clearBoth}></div>
	                    				</div>
	                                    {
	                                    	selection.raceActiveOutcome &&
		                    				<div className="event_row">	
	                    						<div className="td-100 left">{selection.raceActiveOutcome} </div>
	                    						<div style={clearBoth}></div>
	                    					</div>
	                                    }

                    				</>
                        }

                    </div>
                );
            })
		}

	
   </div>
}

export default IsibetHorseTicketSelections;